/** Shared indigo accent: indigo-600 (light), indigo-500 (dark). */

export const SEGMENTED_PILL_TRACK_CLASS =
  "inline-flex shrink-0 items-center rounded-lg bg-slate-100 p-1 dark:bg-slate-800";

export const SEGMENTED_PILL_BUTTON_CLASS =
  "rounded-md px-3 py-1.5 text-sm font-medium transition-colors focus:outline-none focus-visible:ring-2";

export const SEGMENTED_PILL_PRIMARY_FOCUS_RING_CLASS = "focus-visible:ring-indigo-400/40";

export const SEGMENTED_PILL_ACTIVE_CLASS =
  "bg-indigo-600 text-white shadow-sm dark:bg-indigo-500 dark:text-white";

export const SEGMENTED_PILL_INACTIVE_CLASS =
  "text-slate-500 hover:text-slate-700 dark:text-slate-400 dark:hover:text-slate-300";

/** Transparent track; options separated by dividers with a sliding underline (secondary). */
export const SEGMENTED_UNDERLINE_TRACK_CLASS =
  "relative inline-flex shrink-0 items-stretch bg-transparent";

export const SEGMENTED_UNDERLINE_DIVIDER_CLASS =
  "my-1.5 w-px shrink-0 self-stretch bg-slate-300/45 dark:bg-white/8";

export const SEGMENTED_UNDERLINE_BUTTON_CLASS =
  "relative z-[1] bg-transparent px-3 pb-1.5 pt-1.5 text-sm font-normal transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-slate-400/40 focus-visible:ring-offset-0";

export const SEGMENTED_UNDERLINE_ACTIVE_TEXT_CLASS =
  "text-slate-700 dark:text-slate-300";

export const SEGMENTED_UNDERLINE_INACTIVE_TEXT_CLASS =
  "text-slate-500/90 hover:text-slate-600 dark:text-slate-500 dark:hover:text-slate-400";

/** Horizontal inset for the sliding underline within each option button. */
export const SEGMENTED_UNDERLINE_INDICATOR_INSET_PX = 8;

export const SEGMENTED_UNDERLINE_INDICATOR_CLASS =
  "pointer-events-none absolute bottom-0 left-0 h-px rounded-full bg-slate-500/25 transition-[transform,width] duration-300 ease-in-out dark:bg-slate-400/30";

/** Solid accent surface (badges, today markers) — pair with `text-white`. */
export const UI_ACCENT_INDIGO_SURFACE_CLASS = "bg-indigo-600 dark:bg-indigo-500";

export const UI_ACCENT_INDIGO_TEXT_CLASS = "text-indigo-600 dark:text-indigo-400";
